import {
    Box,
    Button,
    Divider,
    Icon,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { SmsCampaignService, SmsTemplateDto } from "../../../api/psc";
import {
    ConfirmationDialog,
    DialogContainer,
    DialogHeader,
    EmptyListMessage,
    Spinner,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import SaveSmsTemplateDialog from "./SaveSmsTemplateDialog";

// updated
export default function ListSmsTemplatesDialog(props: {
    onSelection: (template: string) => void;
}) {
    const [templates, setTemplate] = useState<SmsTemplateDto[]>([]);
    const [isFetching, setIsFetching] = useState(true);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const { openDialog, closeDialog } = useContext(DialogContext);

    useEffect(() => {
        SmsCampaignService.listSmsTemplates("1").then((r) => {
            setTemplate(r);
            setIsFetching(false);
        });
    }, []);

    if (isFetching) {
        return <Spinner />;
    }

    const handleTemplateSelect = (template: string) => {
        props.onSelection(template);
        closeDialog();
    };

    const deleteTemplate = (template: SmsTemplateDto) => {
        setRequestInProgress(true);

        SmsCampaignService.deleteSmsTemplate(template.id, "1")
            .then(() => {
                onTemplateRemoved(template);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const onTemplateAdded = (template: SmsTemplateDto) => {
        setTemplate([...templates, template]);
    };

    const onTemplateUpdated = (updatedTemplate: SmsTemplateDto) => {
        const originalTemplate = templates.find(
            (t) => t.id === updatedTemplate.id
        );
        const indexOfTemplate = templates.indexOf(originalTemplate);
        const updatedTemplates = [...templates];
        if (indexOfTemplate !== -1) {
            updatedTemplates[indexOfTemplate] = updatedTemplate;
        }
        setTemplate(updatedTemplates);
    };

    const onTemplateRemoved = (template: SmsTemplateDto) => {
        setTemplate([...templates.filter((t) => t.id !== template.id)]);
    };

    const openSaveTemplateDialog = () => {
        openDialog(
            <SaveSmsTemplateDialog templateAddedOrUpdated={onTemplateAdded} />
        );
    };

    const openUpdateTemplateDialog = (template: SmsTemplateDto) => {
        openDialog(
            <SaveSmsTemplateDialog
                templateAddedOrUpdated={onTemplateUpdated}
                template={template}
            />
        );
    };

    const openDeleteTemplateDialog = (template: SmsTemplateDto) => {
        openDialog(
            <ConfirmationDialog
                title="آیا نسبت به حذف الگوی انتخاب شده اطمینان دارید؟"
                onAccept={() => deleteTemplate(template)}
            />
        );
    };

    return (
        <DialogContainer>
            <DialogHeader title="لیست پیش نویس ها" />

            <Box sx={{ p: 2, bgcolor: "background.default" }}>
                <Button
                    variant="contained"
                    sx={{ mb: 2 }}
                    fullWidth
                    startIcon={<Icon>add</Icon>}
                    onClick={openSaveTemplateDialog}
                >
                    افزودن پیش نویس جدید
                </Button>

                <EmptyListMessage
                    condition={templates.length === 0}
                    message={"پیش نویسی یافت نشد"}
                />

                <Stack spacing={2}>
                    {templates.map((t) => {
                        return (
                            <Paper sx={{ p: 2 }}>
                                <Stack spacing={1}>
                                    <Typography>{t.template}</Typography>

                                    <Divider />

                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        spacing={1}
                                    >
                                        <Button
                                            color="secondary"
                                            fullWidth
                                            variant="contained"
                                            size="small"
                                            startIcon={<Icon>done</Icon>}
                                            onClick={() =>
                                                handleTemplateSelect(t.template)
                                            }
                                        >
                                            انتخاب
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            startIcon={<Icon>edit</Icon>}
                                            onClick={() =>
                                                openUpdateTemplateDialog(t)
                                            }
                                        >
                                            ویرایش
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            color="error"
                                            disabled={requestInProgress}
                                            startIcon={<Icon>delete</Icon>}
                                            onClick={() =>
                                                openDeleteTemplateDialog(t)
                                            }
                                        >
                                            حذف
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Paper>
                        );
                    })}
                </Stack>
            </Box>
        </DialogContainer>
    );
}
